import { Observable } from 'rxjs';
import { UseCase } from '@/core/base/use-case';
import { TermsConditionsResponse } from '../models/terms-conditions.model';
import { TermsConditionsRepository } from '../repositories/terms-conditions.repository';

export class GetTermsConditionsUseCase
    implements UseCase<never, TermsConditionsResponse>
{
    constructor(private readonly repository: TermsConditionsRepository) {}

    execute(): Observable<TermsConditionsResponse> {
        return this.repository.getTermsConditions();
    }
}
